import React from 'react';
import Container from '../components/Container';
import DonationsPage from '../components/DonationsPage';
import PageHeader from '../components/PageHeader';
import PageSeo from '../components/PageSeo';
import { DonationsProvider } from '../hooks/useDonations';

const Donations = () => {
  const description = 'Support the Shitty Kitties community by donating NFTs to the Shitty Vault and Shitty Vending Machine.';

  return (
    <>
      <PageSeo title='Donate NFTs - Shitty Kitties' description={description} />

      <div className='pb-12 md:pb-48 bg-bg'>
        <PageHeader heading={'Donate NFTs to Shitty Vault'} description={description} />

        <Container>
          <DonationsProvider>
            <DonationsPage />
          </DonationsProvider>
        </Container>
      </div>
    </>
  );
};

export default Donations;
